"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaNumeric = AlphaNumeric;
exports.default = void 0;
function AlphaNumeric(e, setAlphaNumericVal) {
  var targetValue = e.target.value;
  var pattern = /^[a-z\d]+$/i;
  if (targetValue === '' || pattern.test(targetValue)) {
    setAlphaNumericVal([e.target.value]);
  }
}
var _default = AlphaNumeric;
exports.default = _default;